import { ApiVersion } from 'store/apiHeaders/types'

export interface Company {
  id: number
  name: string
  sector: string
  size: string
  location: string
  logo: any
  survey_info: any
  accountId: number
  scorable: boolean
  integrated: boolean
  audit_info: any
  sessions: any[]
  createdAt: string
  [key: string]: any
}

export interface Session {
  id: number
  api_version: string
  start_date: string
  end_date: string
  scorable: boolean | null
  reportLink?: string
  company_id: number
  created_at: string
  updated_at: string
  audit_type: string
}

export interface SessionCamelCase {
  id: number
  apiVersion: ApiVersion
  startDate: string
  endDate: string
  scorable: boolean | null
  reportLink?: string
  companyId: number
  createdAt: string
  updatedAt: string
  auditType: string
}

export interface CompanyState {
  error: any
  invitationSent: boolean
  loading: boolean
  company: Partial<Company>
  sessionIdCurrentlyViewing: number
  latestSession: SessionCamelCase
  version: string
}

export interface Entitlement {
  scopes: EntitlementScopesEnum[]
  entitlements: EntitlementsEnum[]
  enabledEntitlements: {
    [key: string]: {
      id: number
      title: EntitlementsEnum
      scope: EntitlementScopesEnum
    }[]
  }
}

export enum EntitlementScopesEnum {
  AUDIT = 'audit',
  STRATEGY = 'strategy',
  SURVEY = 'survey',
  SURVEY_PART = 'survey_part',
}

export enum EntitlementsEnum {
  REPORTS = 'reports',
  ADVANCED_ASSESSMENT_AUDIT = 'advanced_assessment_audit',
  STRATEGY = 'strategy',
  SURVEYS = 'surveys',
  IS = 'IS',
  DEM = 'DEM',
  PP = 'PP',
}
